export default () => {
	document.querySelectorAll(".announcement-bar").forEach((announcementBar) => {
		const carousel = announcementBar.querySelector(".text-carousel");
		if (!carousel) return;
		const textItems = announcementBar.querySelectorAll(".text-item");
		const leftArrow = announcementBar.querySelector(".arrow--left");
		const rightArrow = announcementBar.querySelector(".arrow--right");
		let activeIndex = 0;
		let isTransitioning = false;

		function updateCarousel() {
			// Fade out current text
			const currentText = textItems[activeIndex];
			currentText.classList.remove("active");

			setTimeout(() => {
				// Update active index
				activeIndex = (activeIndex + 1) % textItems.length;

				// Move buttons
				adjustArrows();

				// Fade in new text
				const newText = textItems[activeIndex];
				newText.classList.add("active");
			}, 450); // Wait for 0.45s fade out to complete
		}

		function adjustArrows() {
			if (textItems.length < 2) return; // Don't do anything when there's only one item
			const activeItem = textItems[activeIndex];
			const activeWidth = activeItem.offsetWidth;
			const activePosition = activeItem.offsetLeft;
			let arrowMargin = 56;

			if (window.innerWidth > 1200) {
				arrowMargin = 64;
			}

			leftArrow.style.left = `${
				activePosition - activeWidth / 2 - leftArrow.offsetWidth - arrowMargin
			}px`;
			rightArrow.style.left = `${
				activePosition + activeWidth / 2 + arrowMargin
			}px`;
		}

		if (textItems.length > 1) {
			leftArrow.addEventListener("click", () => {
				if (!isTransitioning) {
					isTransitioning = true;
					updateCarousel();
					setTimeout(() => (isTransitioning = false), 900);
				}
			});

			rightArrow.addEventListener("click", () => {
				if (!isTransitioning) {
					isTransitioning = true;
					updateCarousel();
					setTimeout(() => (isTransitioning = false), 900);
				}
			});
		}

		function adjustCarouselHeight() {
			let maxHeight = 0;

			textItems.forEach((item) => {
				const height = item.offsetHeight;
				if (height > maxHeight) {
					maxHeight = height;
				}
			});

			carousel.style.height = `${maxHeight}px`;
		}

		// Initialize
		textItems[activeIndex].classList.add("active");
		adjustArrows();
		if (leftArrow) {
			leftArrow.style.visibility = "visible";
		}
		if (rightArrow) {
			rightArrow.style.visibility = "visible";
		}

		function updateOnResize() {
			adjustArrows();
		}

		window.addEventListener("resize", updateOnResize);
	});
};
